<template>
<div class="show-more-btn" @click="$emit('show-more')">
    <svg :class="{'_loading': isLoading}" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M17 -0.000331879C17.5523 -0.000328124 18 0.44739 18 0.999675L18 4.38415C18 4.93643 17.5523 5.38414 17 5.38414H13.5C12.9477 5.38414 12.5 4.93643 12.5 4.38414C12.5 3.83186 12.9477 3.38414 13.5 3.38414H14.4995C13.2172 2.51017 11.6685 2 10 2C5.58172 2 2 5.58172 2 10C2 10.5523 1.55228 11 1 11C0.447715 11 0 10.5523 0 10C0 4.47715 4.47715 -9.53645e-07 10 -9.53645e-07C12.2511 -9.53645e-07 14.3291 0.744557 16 1.99944L16 0.999661C16 0.447377 16.4478 -0.000335574 17 -0.000331879ZM19 9C19.5523 9 20 9.44771 20 10C20 15.5228 15.5228 20 10 20C7.77403 20 5.71708 19.2719 4.05575 18.0422L4.05573 19C4.05572 19.5523 3.608 20 3.05571 20C2.50343 20 2.05572 19.5523 2.05573 19L2.05579 15.7684C2.05579 15.5032 2.16117 15.2488 2.34873 15.0613C2.53629 14.8737 2.79067 14.7684 3.05591 14.7684L6.30339 14.7688C6.85568 14.7689 7.30334 15.2167 7.30327 15.769C7.3032 16.3212 6.85543 16.7689 6.30315 16.7688L5.73346 16.7688C6.96845 17.549 8.43116 18 10 18C14.4183 18 18 14.4183 18 10C18 9.44771 18.4477 9 19 9Z"
            fill="#252628" />
    </svg>
    Показать ещё
</div>
</template>

<script>
// import TheFooter from "./components/TheFooter.vue";

export default {
    name: 'ShowMoreBtn',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {};
    },
    watch: {
        // Здесь можно добавить наблюдатели
    },

    beforeCreate() {
        // Вызывается до создания экземпляра компонента
    },

    created() {
        // Вызывается после создания экземпляра компонента
    },

    beforeMount() {
        // Вызывается перед монтированием компонента
    },

    mounted() {
        // Вызывается после монтирования компонента
    },

    computed: {
        // Здесь можно добавить вычисляемые свойства
    },
    methods: {
        // Здесь можно добавить методы
    }
};
</script>